import { useEffect } from 'react'

export function DeeplinkRedirect() {
  useEffect(() => {
    window.location.href = 'draynow://now'
  }, [])
  return null
}
